import { ArrayUtils } from './Array';

type CacheKeys = (string | number)[];

interface CachedResult<T> {
  keys: CacheKeys;
  result: T;
}

/**
 * Cache a result from a function depending on the value of the given keys.
 */
export class Cached<TParams, TReturn> {
  private _cache: CachedResult<TReturn> | null = null;
  private _func: (params: TParams) => TReturn;

  public get cache(): TReturn | null {
    return this._cache ? this._cache.result : null;
  }

  public constructor(func: (params: TParams) => TReturn) {
    this._func = func;
  }

  public get(params: TParams, keys: CacheKeys): TReturn {
    if (this._cache === null || !ArrayUtils.equals(this._cache.keys, keys)) {
      this._cache = {
        keys,
        result: this._func(params),
      };
    }
    return this._cache.result;
  }
}
